// apiService.js
import axios from 'axios';

const BASE_URL = 'https://rayalaseemauniversity.ac.in/wp/wp-json/wp/v2';

const ApiService = {
  getHeadlines: () => axios.get(`${BASE_URL}/headlines`),
  getSliderImages: () => axios.get(`${BASE_URL}/slider_images`),
  getNotifications: () => axios.get(`${BASE_URL}/notifications`),
  getAchievements: () => axios.get(`${BASE_URL}/achievements`),
  getEvents: () => axios.get(`${BASE_URL}/events`),
  getStats: () => axios.get(`${BASE_URL}/stats`),
};

export default ApiService;
